// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GLow","content":"styles_content__3Ls1h"};